import React from 'react'
import orderBy from 'lodash/orderBy'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import useIconAccessor from 'components/lesson-type-category/icons'
import BookingTypeCard from './booking-type-card'
import useStyles from './styles'

const getFacilityId = selectedFacility =>
  typeof selectedFacility === 'string' ? selectedFacility : selectedFacility?.id

const filterLessonsByLocation = (bookingTypes, selectedFacility) => {
  const facilityId = getFacilityId(selectedFacility)

  if (!facilityId || facilityId === 'all') {
    return bookingTypes
  }

  return bookingTypes.filter(bt => bt.locations?.[0]?.id === facilityId)
}

const sortBtByCategory = bookingTypes => orderBy(bookingTypes, 'category')

const groupByCategory = bookingTypes =>
  bookingTypes.reduce((groups, bookingType) => {
    const lastGroup = groups[groups.length - 1]

    if (!lastGroup || lastGroup.category !== bookingType.category) {
      groups.push({
        category: bookingType.category,
        bookingTypes: [bookingType],
      })
    } else {
      lastGroup.bookingTypes.push(bookingType)
    }

    return groups
  }, [])

export default ({
  title,
  bookingTypes,
  selectedFacility,
  locationFilter,
  refetch,
}) => {
  const classes = useStyles()
  const accessor = useIconAccessor()
  const facilityId = getFacilityId(selectedFacility)
  const filteredBtByLocation = filterLessonsByLocation(
    bookingTypes,
    selectedFacility,
  )

  const filteredBookingTypes =
    facilityId && facilityId !== 'all'
      ? sortBtByCategory(filteredBtByLocation)
      : sortBtByCategory(bookingTypes)

  if (bookingTypes.length === 0) return null

  const categoryGroups = groupByCategory(filteredBookingTypes)

  return (
    <>
      {title ? (
        <Box py={2}>
          <Typography variant="h6" gutterBottom>
            {title}
          </Typography>
        </Box>
      ) : null}
      {locationFilter ? (
        <Box className={classes.listToolbar}>{locationFilter}</Box>
      ) : null}
      {categoryGroups.map(group => (
        <Box
          key={group.category}
          component="section"
          className={classes.categorySection}
        >
          <Typography
            component="h2"
            variant="subtitle1"
            className={classes.categoryLabel}
          >
            {accessor[group.category].text}
          </Typography>
          <Grid direction="row" container spacing={2}>
            {group.bookingTypes.map(bookingType => (
              <Grid
                xs={12}
                md={6}
                lg={4}
                item
                key={bookingType.id}
                style={{ display: 'flex', width: '100%' }}
              >
                <BookingTypeCard bookingType={bookingType} refetch={refetch} />
              </Grid>
            ))}
          </Grid>
        </Box>
      ))}
    </>
  )
}
